import { merge } from 'lodash/fp';

import { StyleValueJustify } from 'lib/inquiryStyles';
import { ImageRemoteComponentStyles } from 'lib/interfaces/ui-components';
import { DeepPartial } from 'lib/types';

export const mockImageRemoteStyles: ImageRemoteComponentStyles = {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  height: { base: { base: null } },
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  width: { base: { base: null } },
  margin: {
    base: {
      base: {
        top: { unit: 'px', value: 0 },
        bottom: { unit: 'px', value: 0 },
        left: { unit: 'px', value: 0 },
        right: { unit: 'px', value: 0 },
      },
    },
  },
  justify: { base: { base: StyleValueJustify.Center } },
  'fill-color': {
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    fill: undefined,
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    background: undefined,
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    highlight: undefined,
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    'original-fill': undefined,
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    'original-background': undefined,
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    'original-highlight': undefined,
  },
  'stroke-color': {
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    stroke: undefined,
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    'original-stroke': undefined,
  },
};

export const createMockImageRemoteStyles = (
  styles?: DeepPartial<ImageRemoteComponentStyles>,
): ImageRemoteComponentStyles => merge(mockImageRemoteStyles, styles);
